import { gql } from '@apollo/client';

export const FETCH_PERCH_CREDIT_CHECK_CONSENT = gql`
  query Flex_FetchPerchCreditCheckConsent {
    currentContractVersions(contractType: consent) {
      id
      displayName
      internalName
      contractType
      notes
      fileUrl
    }
  }
`;
